import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import env from '@/env';
import { ClientVisitDetail } from '../types';

export const getClientVisitById = async (
  id: string,
  lang: string = ''
): Promise<ClientVisitDetail> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/client-visits/${id}?${new URLSearchParams({
      lang,
    })}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as ClientVisitDetail;
  return response;
};
